import { useAppSelector } from '@core/js/store/hooks';

import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';

export const useDynamicTags = (dynamicTags: DYNAMIC_TAG_NAMES[]): (string | undefined)[] => {
    return useAppSelector((state) => dynamicTags.map((tag) => state.dynamicTags?.[`DTAG_${tag}`]));
};
